// function goBack() {
//   window.history.back();
// }

// $(document).on("click",".sticky-add-to-cart-btn",function() {
//   $('.buy-button-row product-form .product-form__submit').click();
// });

// $(document).on("click",".sticky-add-to-cart-buy-btn",function() {

//     // Get form data
//     var formData = $('.buy-button-row product-form form').serialize();

//     // Send AJAX request to Shopify's cart API
//     $.ajax({
//       type: 'POST',
//       url: '/cart/add.js',
//       data: formData,
//       dataType: 'json',
//       success: function (response) {
//         window.location.href = "/checkout"
//       },
//       error: function (xhr, status, error) {
//         $('#cart-message').text('Error adding product to cart.');
//         console.log('Error:', error);
//       }
//     });
// });
  
// $( document ).ready(function() {
//    if($('fw-embed-feed').length > 0){
//      // var id = $('fw-embed-feed').parents('.shopify-app-block').attr('id');
//      $('.watch-videos').css('opacity', '1');
//      // $('.watch-videos').attr('href', '#'+id+'');
//    }

//   $(document).on("click",".watch-videos",function() {
//     $(window).scrollTop(($(window).scrollTop()+document.querySelector('fw-embed-feed').getBoundingClientRect().top)-50)
//   });
// });


function goBack() {
  window.history.back();
}

$(document).on("click",".sticky-add-to-cart-btn",function() {
  $('.buy-button-row product-form .product-form__submit').click();
});

$(document).on("click",".sticky-add-to-cart-buy-btn",function() {

    // Get form data
    var formData = $('.buy-button-row product-form form').serialize();

    // Send AJAX request to Shopify's cart API
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: formData,
      dataType: 'json',
      success: function (response) {
        window.location.href = "/checkout"
      },
      error: function (xhr, status, error) {
        $('#cart-message').text('Error adding product to cart.');
        console.log('Error:', error);
      }
    });
});
  
$( document ).ready(function() {
   if($('fw-embed-feed').length > 0){
     // var id = $('fw-embed-feed').parents('.shopify-app-block').attr('id');
     $('.watch-videos').css('opacity', '1');
     // $('.watch-videos').attr('href', '#'+id+'');
   }

  $(document).on("click",".watch-videos",function() {
    const fireworkFeed = document.querySelector('fw-embed-feed');
    if (!fireworkFeed) return;

    $(window).scrollTop(($(window).scrollTop()+fireworkFeed.getBoundingClientRect().top)-50)
  });
});